'use client';

import { useContext } from 'react';
import { useSearchParams } from 'next/navigation';
import { HomeAppShell } from '../components/HomeAppShell/HomeAppShell';
import { RequiresAuthnAndData } from "../components/RequiresAuthnAndData";
import { HomeContext } from '../lib/context';
import { GUIDES_TAB_NAME } from '../components/TravelScrollMenu';
import { useIsRestoringRoute } from '../lib/useRouteRestoration';

export default function HomePage() {
    const { uidPlaces, userTrips, uidGuides } = useContext(HomeContext);
    const searchParams = useSearchParams();
    const tab = searchParams.get('tab');
    const place = searchParams.get('place');

    // While a cold-launch restore is in flight, hold the loader so HomeAppShell never mounts
    // (and never kicks off its home-only queries) just to be torn down by the restore replace.
    const isRestoring = useIsRestoringRoute();

    return <RequiresAuthnAndData
        isLoading={isRestoring}
        supportsCachedAuth
        childProvider={userData =>
            <HomeAppShell
                userid={userData.firebaseUserId}
                tab={tab ?? GUIDES_TAB_NAME}
                selected={place}
                userTrips={userTrips}
                userGuides={uidGuides}
                savedUidPlaces={uidPlaces}
            />
        }
    />;
}

HomePage.debugId = 'Index';
